import styled from '@emotion/styled';

export const PortalContainer = styled.div<{ zIndex?: number }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex};
`;
